<template>
  <Modal
    :open="displayModal"
    title="Restore Sale"
    size="large"
    :showEscapeButton="true"
    :showAcceptButton="true"
    :showDangerButton="false"
    acceptButtonText="Restore &amp; Accept Sale"
    @close="displayModal = false"
    @onSuccess="restoreSale"
    ref="modal"
  >
    <dl class="grid grid-cols-1 gap-4 sm:grid-cols-2" v-if="data !== null">
      <div class="col-span-1 sm:col-span-2">
        <dt class="text-sm font-medium text-gray-600">
          Video Title
        </dt>
        <dd class="mt-1 text-sm text-gray-900">
          {{ data.video.title }}
        </dd>
      </div>
      <div class="sm:col-span-1">
        <dt class="text-sm font-medium text-gray-600">
          Purchasing Network
        </dt>
        <dd class="mt-1 text-sm text-gray-900">
          {{ data.network.name }}
        </dd>
      </div>
      <div class="sm:col-span-1">
        <dt class="text-sm font-medium text-gray-600">
          Purchasing User
        </dt>
        <dd class="mt-1 text-sm text-gray-900">
          {{ data.purchaser.name }}
        </dd>
      </div>
      <div class="sm:col-span-1" v-if="data.owner">
        <dt class="text-sm font-medium text-gray-600">
          Video Owner
        </dt>
        <dd class="mt-1 text-sm text-gray-900">
          {{ data.owner.name }}
        </dd>
      </div>
      <div class="sm:col-span-1">
        <dt class="text-sm font-medium text-gray-600">
          Purchase Price
        </dt>
        <dd class="mt-1 text-sm text-gray-900">${{ data.price }}</dd>
      </div>
      <div class="sm:col-span-2">
        <dt class="text-sm font-medium text-gray-600">
          Video Rating
        </dt>
        <dd class="mt-1 text-sm text-gray-900">
          {{ data.video.rating }}
        </dd>
      </div>

      <div class="sm:col-span-1">
        <label
          for="video_price_override"
          class="block text-sm font-medium text-gray-600"
          >Purchase Price Override</label
        >

        <div class="mt-1 relative rounded-md shadow-sm">
          <div
            class="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none"
          >
            <span class="text-gray-500 sm:text-sm">
              $
            </span>
          </div>
          <input
            type="number"
            name="video_price_override"
            id="video_price_override"
            class="focus:ring-blue-500 focus:border-blue-500 block w-full pl-7 pr-12 sm:text-sm border-gray-300 rounded-md shadow-sm "
            placeholder="0"
            aria-describedby="price-currency"
            v-model="data.price"
          />
          <div
            class="absolute inset-y-0 right-0 pr-3 flex items-center pointer-events-none"
          >
            <span class="text-gray-500 sm:text-sm" id="price-currency">
              USD
            </span>
          </div>
        </div>
      </div>

      <div class="sm:col-span-1">
        <label
          for="invoice_number"
          class="block text-sm font-medium text-gray-600"
          >Invoice Number</label
        >

        <input
          type="number"
          name="invoice_number"
          id="invoice_number"
          class="mt-1 focus:ring-blue-500 focus:border-blue-500 block w-full pl-4 pr-4 sm:text-sm border-gray-300 rounded-md shadow-sm "
          placeholder="0"
          aria-describedby="price-currency"
          v-model="invoiceNumber"
        />
      </div>

      <div class="sm:col-span-1">
        <div class="flex flex-row justify-between">
          <label
            for="stringer_percent"
            class="block text-sm font-medium text-gray-600"
            >Stringer Percent
          </label>
          <span
            class="block text-sm font-medium text-blue-800 cursor-pointer select-none"
            v-on:click="modifyStringerPercent(user)"
            >Modify Default</span
          >
        </div>

        <div class="mt-1 relative rounded-md shadow-sm">
          <input
            type="number"
            name="stringer_percent"
            id="stringer_percent"
            class="focus:ring-blue-500 focus:border-blue-500 block w-full pl-4 pr-4 sm:text-sm border-gray-300 rounded-md shadow-sm "
            placeholder="0"
            aria-describedby="price-currency"
            v-model="percent"
            @keyup="calculateStringerAmount"
          />
          <div
            class="absolute inset-y-0 right-0 pr-3 flex items-center pointer-events-none"
          >
            <span class="text-gray-500 sm:text-sm" id="price-currency">
              %
            </span>
          </div>
        </div>
      </div>
      <div class="sm:col-span-1">
        <label
          for="stringer_amount"
          class="block text-sm font-medium text-gray-600"
          >Stringer Amount</label
        >

        <div class="mt-1 relative rounded-md shadow-sm">
          <div
            class="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none"
          >
            <span class="text-gray-500 sm:text-sm">
              $
            </span>
          </div>
          <input
            type="number"
            name="stringer_amount"
            id="stringer_amount"
            class="focus:ring-blue-500 focus:border-blue-500 block w-full pl-7 pr-12 sm:text-sm border-gray-300 rounded-md shadow-sm "
            placeholder="0"
            aria-describedby="price-currency"
            v-model="stringerAmount"
          />
          <div
            class="absolute inset-y-0 right-0 pr-3 flex items-center pointer-events-none"
          >
            <span class="text-gray-500 sm:text-sm" id="price-currency">
              USD
            </span>
          </div>
        </div>
      </div>
    </dl>
    <UserModifyPercentModal />
  </Modal>
</template>

<script>
import * as Config from "@/config";
import { mapActions } from "vuex";

import Modal from "@/components/Modal";
import UserModifyPercentModal from "@/screens/admin/modals/UserModifyPercentModal";

export default {
  data() {
    return {
      displayModal: false,
      data: null,
      user: {},
      stringerAmount: 0,
      invoiceNumber: null,
      percent: 0,
      isProgressing: false
    };
  },

  components: {
    Modal,
    UserModifyPercentModal
  },

  mounted() {
    this.$nextTick(
      function() {
        this.$eventBus.$on("admin-sale-deleted-open-modal", this.open);
      }.bind(this)
    );
    this.$nextTick(
      function() {
        this.$eventBus.$on(
          "admin-modify-stringer-percent-return",
          this.updatePercent
        );
      }.bind(this)
    );
  },

  destroyed() {
    this.$eventBus.$off("admin-sale-deleted-open-modal", this.open);
    this.$eventBus.$off(
      "admin-modify-stringer-percent-return",
      this.updatePercent
    );
  },

  watch: {
    "data.price": function() {
      this.calculateStringerAmount();
    }
  },

  methods: {
    ...mapActions(["addToastMessage"]),
    open(data) {
      this.displayModal = true;
      this.data = data;

      // get users percent
      this.getUserDetails(data.owner_id);
      this.calculateStringerAmount();
    },

    async getUserDetails(owner_id) {
      const res = await this.$http.get(
        Config.apiPath + "/api/v2/admin/users/" + owner_id
      );
      this.user = res.data;
      if (res.data.settings !== null) {
        this.percent = res.data.settings.percent;
        this.calculateStringerAmount();
      }
    },

    calculateStringerAmount() {
      var sale = this.data.price;
      var stringerPercent = this.percent;
      this.stringerAmount = sale * (stringerPercent / 100);
    },

    async restoreSale() {
      var data = {
        id: this.data.id,
        price: this.data.price,
        stringer_cut: this.stringerAmount,
        invoiceNumber: this.invoiceNumber
      };

      this.data.status = "approved";

      const res = await this.$http.post(
        Config.apiPath + "/api/v2/admin/sales/restore",
        data
      );
      if (res.status == 200) {
        this.addToastMessage({
          title: "Success",
          text: "Sale was restored.",
          type: "success"
        });
      }
      this.displayModal = false;
      this.$eventBus.$emit("admin-approve-sale-refresh-data");
    },

    modifyStringerPercent() {
      this.$eventBus.$emit(
        "admin-modify-stringer-percent-open-modal",
        this.user
      );
    },
    updatePercent(percent) {
      this.percent = percent;
      this.calculateStringerAmount();
    }
  }
};
</script>
